module.exports = __webpack_public_path__ + "img/pool.202512e5.jpg";